import styles from './styles.module.css';
import React from 'react';

interface LegalViewerProps {
  htmlContent: string;
}

const LegalViewer = ({ htmlContent }: LegalViewerProps) => {
  return (
    <div className={styles.legalText}>
      <div className="legalText" dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </div>
  );
};

export default LegalViewer;
